import {createRouter, createWebHistory, type RouteMeta} from "vue-router";

declare module 'vue-router' {
    interface RouteMeta {
        title?: string
        authorized?: boolean
    }
}
const defaultTitle = 'Core Digital Technology';

// 기본값을 가진 meta 객체
const defaultMeta: Required<RouteMeta> = {
    title: defaultTitle,
    authorized: false
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: () => {
        window.location.href = '/tools-list.html'
        return '/'  // 폴백 경로
      }
      , meta: { title: 'Business tools' }
    },
    { path: '/admin', meta: {authorized: true}, children: [
          { path: '/admin/version', name: 'version', component: () => import('@/views/admin/version/Version.vue') }
      ]
    },
    { path: '/biz-tools', meta: {authorized: false}, children: [
        { path: '/biz-tools/calculate-meeting-time', name: 'version', component: () => import('@/views/biz-tools/CalculateMeetingTime.vue'), meta: { title: 'Meeting planner' }, },
      ]
    },
    { path: '/usecase', meta: {authorized: true}, children: [
        { path: '/usecase/cdt-action-buttons', component: () => import('@/views/guide/Usecase-CDTActionButtons.vue') },
        { path: '/usecase/cdt-pagination', component: () => import('@/views/guide/Usecase-CDTPagination.vue') },
        { path: '/usecase/cdt-modal', component: () => import('@/views/guide/Usecase-CDTModal.vue') },
        { path: '/usecase/cdt-background', component: () => import('@/views/guide/Usecase-CDTBackgroundImg.vue') },
        { path: '/usecase/cdt-time-dial', component: () => import('@/views/guide/Usecase-CDTTimeDial.vue') }
      ]
    }
  ],
});

router.afterEach((to, from) => {
    document.title = to.meta.title || defaultTitle;
});

export default router;
